import { render, staticRenderFns } from "./bindAcct.vue?vue&type=template&id=5f9355e2"
import script from "./bindAcct.vue?vue&type=script&lang=js"
export * from "./bindAcct.vue?vue&type=script&lang=js"
import style0 from "./bindAcct.vue?vue&type=style&index=0&id=5f9355e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports